import { render, staticRenderFns } from "./custprg_labels.vue?vue&type=template&id=1093c989&scoped=true&lang=html"
import script from "./custprg_labels.vue?vue&type=script&lang=js"
export * from "./custprg_labels.vue?vue&type=script&lang=js"
import style0 from "./custprg_labels.vue?vue&type=style&index=0&id=1093c989&prod&lang=css"
import style1 from "./custprg_labels.vue?vue&type=style&index=1&id=1093c989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093c989",
  null
  
)

export default component.exports